module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./BankCardModifyView.js"));
	}, "BankCardModifyView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BankCardModifyView!./src/pages/Shop/Member/Wallet/BankCard/BankCardModify/BankCardModifyView.js
// module id = 1080
// module chunks = 431